import React, { useEffect, useRef } from 'react';
import * as classes from './index.module.css';
import { useStore, setScrollPosition } from '@UseCase/store';
import PropTypes from 'prop-types';
import Logo from '../Logo';
import Navigation from '../Navigation';
import { useStaticQuery, graphql } from 'gatsby'
import RichText from '@components/RichText'

const Header = React.forwardRef(({ location }, ref) => {
  const [store, dispatch] = useStore();
  const { isInLightSection, headerBG, scrollPosition } = store;

  const { contentfulGlobalConfigurations: {
        headerMessage
    }} = useStaticQuery(
        graphql`
            query {
                contentfulGlobalConfigurations {
                    headerMessage {
                      raw
                    }
                }
            }
        `
    )

  useEffect(() => {
    const updateScrollPosition = () => {
      setScrollPosition(dispatch, window.scrollY);
    };

    window.addEventListener('scroll', updateScrollPosition);
    updateScrollPosition(); // Initial call

    return () => {
      window.removeEventListener('scroll', updateScrollPosition);
    };
  }, []);

  return (
    <header ref={ref} className={classes.root}>
      {headerMessage && 
        <div className={classes.headerMessage}>
          <div className={classes.cont}>
            <RichText content={headerMessage}/>
          </div>
        </div>
      }
      <div className={`${classes.headerContainer} ${(headerBG && scrollPosition < 100)  && classes.withBG } ${isInLightSection ? !headerBG ? classes.lightRoot : scrollPosition > 100 &&  classes.lightRoot: classes.darktRoot}`}>
        <div className={classes.cont}>
          <div className={classes.row}>
            <Logo location={location} />
            <Navigation location={location} />
          </div>
        </div>
      </div>
    </header>
  );
});

Header.propTypes = {
  location: PropTypes.object,
};

export default Header;
